import { Store } from "lucide-react";

/** Testata verde presente su ogni schermata del percorso cliente (§3.1, §8): nome
 *  dell'agenzia, così chi ha inquadrato il cartello sa dove si trova. */
export function QrTesta({ agenzia }: { agenzia: string }) {
  return (
    <header className="bg-sidebar text-white px-5 py-4 flex items-center gap-2 shrink-0">
      <Store className="w-5 h-5 text-brand-light" aria-hidden="true" />
      <span className="text-lg font-semibold">{agenzia}</span>
    </header>
  );
}

/** Barra dei passi (bozzetti §2, schermate 1/3-3/3): tre segmenti, il testo del
 *  passo corrente sotto. Il testo esatto ("1 di 3 · Bolletta" ecc.) arriva da §8. */
export function PassoBar({ passo, testo }: { passo: 1 | 2 | 3; testo: string }) {
  return (
    <div className="px-6 pt-4 shrink-0">
      <div className="flex gap-1.5" role="img" aria-label={testo}>
        {[1, 2, 3].map((n) => (
          <span key={n} className={`h-1.5 flex-1 rounded ${n <= passo ? "bg-brand" : "bg-border"}`} />
        ))}
      </div>
      <p className="text-lg text-muted-foreground mt-2">{testo}</p>
    </div>
  );
}
